// @modified: enabne event fire, because most request use event
// @version V1.0.0 : disable events fire, dispatchOrCommit -> commit only
// @version V0.0.2 [Saturday - 20210130_012704] : add boolean return
// @version V0.0.1 [Monday - 20201130_215526] : init
import { sendRequest } from "../request";

export function requestSubmit(url, form, commit, method = 'post', successCallback = () => {}, errorCallback = () => {}, finishCallback = () => {}) {
    commit('requestStatus/REQUEST_SENDING', null, { root : true})
    commit('requestStatus/RESET_ERROR_RESPONSE', null, { root : true})
    return sendRequest(url, form, method, 
        (successResponse) => {
            commit('requestStatus/REQUEST_SUCCESS', null, { root : true})
            successCallback(successResponse)
            return true
        },
        (failedResponse) => {
            commit('requestStatus/REQUEST_FAILED', null, { root : true})
            commit('requestStatus/SET_ERROR_RESPONSE', failedResponse, { root : true})
            errorCallback(failedResponse)
            return false
        },
        (resultBoolean) => {
            commit('requestStatus/REQUEST_SENDED', null, { root : true})
            finishCallback()
            return resultBoolean
        }, true, true
    )
} 
